import React, {Component} from 'react';
import {Col, ControlLabel, Form, FormGroup} from "react-bootstrap";


export default class WynajemContainer extends Component {
    constructor(props) {
        super(props);

        if (localStorage.getItem('EBUS_EdycjaWynajem') === null){
            this.state = {
                opis: ''
            };
        } else {
            this.state = {
                opis: this.props.data.opis,
            };
        }

        this.onChangeOpis = this.onChangeOpis.bind(this);
    }

    onChangeOpis(e) {
        this.setState({opis: e.target.value})
        this.props.setOpis(e.target.value)
    }

    render() {
        return (
            <Col sm={6} style={{marginTop: 15}}>
                <fieldset>
                    <div className={'fieldset-label'}>Opis</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} lg={12}>
                                <ControlLabel>Opis:</ControlLabel>
                                <textarea className="form-control" style={{marginBottom: 12, resize: 'none'}} rows={12} maxLength={3000} onChange={this.onChangeOpis}
                                       value={this.state.opis}/>
                            </Col>
                        </FormGroup>
                    </Form>
                </fieldset>
            </Col>

        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/formularz/components/DaneOpis.js